<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="createVisible"
    v-loading="createProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Create Announcement</h1>
        <div class="modal-actions col-2">
          <el-button
            type="primary"
            :disabled="!createForm.mediaFileId || !createForm.name"
            @click="createOperation"
            >Create</el-button
          >
          <el-button type="default" @click="cancelOperation">Cancel</el-button>
        </div>
      </div>
    </div>

    <el-form>
      <div class="inline-form-group">
        <el-checkbox
          :value="createForm.active"
          @change="createForm.active = !createForm.active"
        >
          Active
        </el-checkbox>
      </div>

      <div class="inline-form-group">
        <el-input v-model="createForm.name" placeholder="Enter name*">
          <template slot="prefix"><span>Name</span></template>
        </el-input>
      </div>

      <el-input
        id="note"
        type="textarea"
        placeholder="Enter a description"
        v-model="createForm.description"
        :autosize="{ minRows: 4 }"
      />

      <dads-select
        v-model="createForm.branchId"
        placeholder="Branch"
        filterable
      >
        <template slot="prefix"> Branch</template>
        <el-option
          v-for="branch in branchOptions"
          :key="branch.id"
          :value="branch.id"
          :label="branch.name"
        />
      </dads-select>

      <div class="inline-form-group">
        <div class="flex column left">
          <h3 class="black-text">Announcement Dates</h3>
          <el-date-picker
            v-model="createForm.dateRange"
            style="margin-bottom: 20px"
            type="datetimerange"
            align="right"
            unlink-panels
            format="yyyy-MM-dd HH:mm"
            :clearable="false"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          />
          <div>
            <el-tag type="primary" size="small">
              <i class="el-icon-info"></i>
              Date range applies to IVR announcements only
            </el-tag>
          </div>
        </div>
      </div>

      <dads-select
        clearable
        filterable
        remote
        multiple
        placeholder="Select IVR"
        v-model="createForm.ivrIds"
        :remote-method="getIvrOptions"
      >
        <template slot="prefix"> IVR </template>
        <el-option
          v-for="{ id, name } in ivrOptions"
          :key="id"
          :label="`${name}`"
          :value="id"
        />
      </dads-select>

      <div class="inline-form-group">
        <hr />
      </div>

      <div class="inline-form-group">
        <existing-mediafile
          style="width: 100%"
          title="Media Files"
          :required="true"
          :multiple="false"
          :clearState="clearFormFields"
          :newMediafile="newMediafile"
          @mediafileSelected="createForm.mediaFileId = $event"
        />
      </div>

      <div class="inline-form-group">
        <announcements-new-mediafile @mediafileSaved="newMediafile = $event" />
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import ExistingMediafile from "@/components/ExistingMediafile";
import moment from "moment/moment";
import MultiTimeRangeSelector from "@/views/pages/time-of-days/components/multiTimeRangeSelector.vue";
import DadsSelect from "@/components/select";
import AnnouncementsNewMediafile from "@/views/pages/announcements/components/announcements-new-media-file.vue";

export default {
  name: "AnnouncementsCreateForm",

  props: {
    createVisible: { required: true },
    createProcessing: { required: true },
    clearFormFields: { required: true },
    branchOptions: { required: true },
    ivrOptions: { required: true },
    getIvrOptions: { type: Function, required: true }
  },

  components: {
    AnnouncementsNewMediafile,
    DadsSelect,
    MultiTimeRangeSelector,
    ExistingMediafile
  },

  data() {
    return {
      newMediafile: null,
      createForm: {
        tenantId: null,
        name: "",
        description: "",
        branchId: this.defaultBranchId,
        dateRange: [moment(), moment()],
        active: false,
        ivrIds: [],
        mediaFileId: null
      }
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    defaultBranchId() {
      if (this.branchOptions && this.branchOptions.length > 0) {
        const defaultBranch = this.branchOptions.find(
          (branch) => branch.default === 1
        );
        return defaultBranch.id;
      }
      return null;
    }
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },
    branchOptions: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0 && !this.createForm.branchId) {
          this.createForm.branchId = this.defaultBranchId;
        }
      }
    }
  },

  methods: {
    createOperation() {
      const createBody = { ...this.createForm };
      createBody.tenantId = this.selectedTenant.id;

      this.$emit("createOperation", createBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "create");
    },

    clearFields() {
      this.newMediafile = null;
      this.createForm = {
        tenantId: null,
        name: "",
        description: "",
        dateRange: [moment(), moment()],
        active: false,
        ivrIds: [],
        branchId: this.defaultBranchId,
        mediaFileId: null
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.inline-form-group .el-checkbox {
  margin-left: 0;
}
</style>
